import { Vote, Loader2 } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { useVotingStats, useToggleVoting, useFinalizeVoting } from '@/api';

export function AdminVotingPage() {
  const { data: votingData, isLoading } = useVotingStats();
  const toggleVoting = useToggleVoting();
  const finalizeVoting = useFinalizeVoting();

  const characters = votingData?.data?.characters ?? [];

  return (
    <div>
      <h1 className="font-['Poppins',sans-serif] text-4xl font-semibold text-white mb-3">
        Voting Management
      </h1>
      <p className="text-lg text-[#9595a5] mb-10">Manage voting phase and finalize results</p>

      <div className="flex flex-wrap gap-4 mb-10">
        <Button
          onClick={() => toggleVoting.mutate()}
          disabled={toggleVoting.isPending}
          className="bg-white text-black hover:opacity-90 rounded-xl"
        >
          {toggleVoting.isPending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Vote className="w-4 h-4 mr-2" />}
          Toggle Voting
        </Button>
        <Button
          onClick={() => finalizeVoting.mutate()}
          disabled={finalizeVoting.isPending}
          variant="outline"
          className="border-white/[0.08] text-white hover:bg-white/[0.04] rounded-xl"
        >
          {finalizeVoting.isPending ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
          Finalize Voting
        </Button>
        {(toggleVoting.isError || finalizeVoting.isError) && (
          <span className="text-sm text-red-400 flex items-center">
            {toggleVoting.error?.message ?? finalizeVoting.error?.message}
          </span>
        )}
      </div>

      {isLoading ? (
        <div className="p-10 rounded-xl bg-[#18181f] border border-white/[0.08] text-[#9595a5] text-center">
          Loading...
        </div>
      ) : characters.length > 0 ? (
        <div className="space-y-4">
          {characters.map((char) => (
            <div
              key={char._id}
              className="p-6 rounded-xl bg-[#18181f] border border-white/[0.08]"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-['Poppins',sans-serif] text-lg font-semibold text-white">{char.name}</h3>
                <span className="text-sm text-[#9595a5]">
                  {char.yesVotes} yes · {char.noVotes} no · {char.totalVotes} total
                </span>
              </div>
              <p className="text-sm text-[#9595a5] mb-3 line-clamp-2">{char.description}</p>
              <div className="w-full h-2 rounded-full bg-[#2a2a35] overflow-hidden">
                <div
                  className="h-full bg-white transition-all duration-500"
                  style={{ width: `${char.yesPercentage}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="p-10 rounded-xl bg-[#18181f] border border-white/[0.08] text-[#9595a5] text-center">
          No characters in voting
        </div>
      )}
    </div>
  );
}
